import { Grid, Typography } from "@mui/material";
import Container from "@mui/material/Container";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import Network from "./Network";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import { MOBILE_NUMBER } from "../constants/contacts";
import { ReactComponent as LogoSvg } from "../assets/logo.svg";

import { ReactComponent as LogoLetterSvg } from "../assets/logo-letter.svg";

import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

function createData(day, hours) {
  return { day, hours };
}

const rows = [
  createData("Понеділок", "9:00 - 18:00"),
  createData("Вівторок", "9:00 - 18:00"),
  createData("Середа", "9:00 - 18:00"),
  createData("Четвер", "9:00 - 18:00"),
  createData("П'ятниця", "9:00 - 18:00"),
  createData("Субота", "Вихідний"),
  createData("Неділя", "Вихідний"),
];

export default function Footer() {
  const location = useLocation();
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    const shouldFocus = location.state?.highlight === true;

    if (shouldFocus) {
      setFocused(true);

      const el = document.getElementById("footer");
      el?.scrollIntoView({ behavior: "smooth", block: "start" });

      const t = setTimeout(() => setFocused(false), 4000);
      return () => clearTimeout(t);
    }
  }, [location.state]);
  return (
    <Box component="footer" id="footer" sx={{ color: "#f5c33d" }}>
      <Container>
        <Grid container spacing={2} p={2} justifyContent="center">
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Container
              p={2}
              className={focused ? "footer-focus" : ""}
              sx={{
                transition: "transform 0.5s ease, filter 0.5s ease",
              }}
            >
              <Typography variant="h5">Наші контакти</Typography>
              <Container
                sx={{ mt: 1, gap: 2, display: "flex", flexDirection: "column" }}
              >
                <a
                  href={`tel:${MOBILE_NUMBER}`}
                  style={{
                    textDecoration: "none",
                    color: "#f5c33d",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px",
                  }}
                >
                  <LocalPhoneIcon style={{ width: 20, height: 20 }} />
                  <span>{MOBILE_NUMBER}</span>
                </a>
                <Box>Пн-Пт 10:00-18:00</Box>
                <Box>м. Ужгород</Box>
              </Container>
            </Container>
          </Grid>
        </Grid>
        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
          mb={3}
          sx={{
            "@keyframes pulse": {
              "0%": { transform: "scale(1)" },
              "50%": { transform: "scale(1.12)" },
              "100%": { transform: "scale(1)" },
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              lineHeight: 0,
              my: 5,
            }}
          >
            <LogoSvg
              style={{
                width: "6rem",
                height: "6rem",
                display: "block",
                transformOrigin: "center",
                animation: "pulse 2s infinite",
              }}
            />
          </Box>

          <Typography
            variant="h5"
            sx={{
              color: "#f5c33d",
              textAlign: "right",
              width: "100%",
              fontStyle: "italic",
            }}
            className="great-vibes-regular"
          >
            З любов'ю.
             <LogoLetterSvg
    style={{
      width: "1.2em",
      height: "1.2em",
      verticalAlign: "sub",
    }}
  />
          </Typography>
        </Grid>
      </Container>
    </Box>
  );
}
